import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'info-loader',
  templateUrl: './info-loader.component.html',
  styleUrls: ['./info-loader.component.scss']
})
export class InfoLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
